// src/components/Message.js

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideMessage } from "../slice/messageSlice";
import { Toast, ToastContainer } from "react-bootstrap";

const Message = () => {
  const dispatch = useDispatch();
  const { showMessage, message, type } = useSelector((state) => state.message);

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        dispatch(hideMessage());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showMessage, dispatch]);

  if (!showMessage) {
    return null;
  }

  return (
    <ToastContainer
      position="top-center"
      className="p-3 toast-container position-fixed"
    >
      <Toast
        onClose={() => dispatch(hideMessage())}
        show={showMessage}
        className={`toast-${type}`}
      >
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Message;
